import { useEffect } from "react";

const BASIS = "LILASp Projekte";

/**
 * Setzt den Dokumenttitel und stellt ihn beim Verlassen zurück.
 *
 * Warum überhaupt: mit mehreren offenen Reitern ist der Titel die einzige
 * Stelle, an der man sieht, welcher davon welches Projekt zeigt — und ein
 * Einzelseiten-Programm ändert ihn von sich aus nie.
 */
export function useTitel(titel?: string): void {
  useEffect(() => {
    const vorher = document.title;
    document.title = titel ? `${titel} · ${BASIS}` : BASIS;
    return () => {
      document.title = vorher;
    };
  }, [titel]);
}
